<!-- 发布信息状态 -->
<template>
  <div class="container">
    <ul>
      <li :class="{active:navStatus==index}" v-for="(item,index) in status">{{item}}</li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      status: ["1.选择类别", "2.填写信息", "3.完成发布"]
    };
  },
  props:{
    navStatus:{
      default:0
    }
  },
  components: {}
};
</script>

<style scoped>
.container {
  width: 100%;
}
ul {
  width: 1200px;
  box-sizing: border-box;
  padding: 0 12px;
  margin: 0 auto;
  background: #fff;
}
ul li {
  display: inline-block;
  width: 370px;
  box-sizing: border-box;
  font-size: 18px;
  color: #b2b2b2;
  border-bottom: 2px solid #b2b2b2;
  margin-right: 33px;
}
ul li.active {
  color: #00A0E9;
  border-bottom: 2px solid #00A0E9;
}
ul li:last-child {
  margin-right: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/PublishStatus.vue